import { CircuitMealPlanForm, CircuitMealPlanLocalization, CircuitMealPlanPriceRange } from "../objects/circuitMealPlan";
import { CircuitMealPlanListConfiguration, CircuitMealPlanListCriteria, CircuitMealPlanListFiltersCriteria } from "../objects/circuitMealPlanList";
import { Column } from "../objects/column";


export const EMPTY_MEAL_PLAN: CircuitMealPlanForm = {
    id: 0,
    name: "",
    description: "",
    prices: [],
    localization: [],
    name_locales: {},
    description_locales: {}
};

export const EMPTY_MEAL_PLAN_LOCALIZED: CircuitMealPlanLocalization = {
    name: "",
    description: "",
    locale: 0
};

export const EMPTY_MEAL_PLAN_PRICE_RANGE: CircuitMealPlanPriceRange = {
    periods: [],
    period_id: [],
    contract_id: null,
    price: "",
    com_price: "",
    markup_price: "",
    selling_price: "",
    price_per_day: false
};

export const EMPTY_MEAL_PLAN_FILTERS: CircuitMealPlanListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};

export const EMPTY_MEAL_PLAN_LIST_CRITERIA: CircuitMealPlanListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_MEAL_PLAN_FILTERS,
    search: ''
};




export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'meal-type',
    field_name: 'MEAL_TYPE',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_MEAL_PLAN_LIST_CONFIGURATION: CircuitMealPlanListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const CIRCUIT_MEAL_PLAN_MODULE = 'CIRCUIT_MEAL_PLAN_MODULE';